export default function CustomHomeBuildersServices() {
  const services = [
    {
      icon: 'ri-home-heart-line',
      title: 'Custom Design and Architecture',
      description: `Custom home building begins with personalized design that reflects your lifestyle and preferences. El Paso builders work with architects to create plans suited to our desert climate, incorporating energy-efficient features, optimal sun orientation, and outdoor living spaces. Design phase typically takes 2-4 months and includes 3D renderings, material selections, and detailed specifications. Quality builders ensure designs comply with local codes while maximizing your lot's potential.`
    },
    {
      icon: 'ri-leaf-line',
      title: 'Energy-Efficient Construction',
      description: `Energy efficiency is critical in El Paso where cooling costs dominate. Expert builders incorporate enhanced insulation, high-performance windows, reflective roofing, and efficient HVAC systems. Smart home technology controls lighting, temperature, and security. Proper orientation minimizes sun exposure on west-facing walls. Energy-efficient homes reduce utility bills by 30-50% and qualify for rebates from El Paso Electric. Initial investment pays back through decades of savings.`
    },
    {
      icon: 'ri-building-2-line',
      title: 'Southwestern Architecture Specialists',
      description: `Southwestern style dominates El Paso's custom home market, featuring stucco exteriors, tile roofs, arched doorways, and courtyards. Modern interpretations blend traditional elements with contemporary design. Builders experienced in regional architecture understand proper stucco application, authentic tile installation, and creating indoor-outdoor flow. Materials must withstand intense UV exposure and temperature extremes while maintaining aesthetic appeal.`
    },
    {
      icon: 'ri-hammer-line',
      title: 'Site Preparation and Foundation',
      description: `El Paso's caliche soil and rocky terrain require specialized site preparation. Quality builders conduct soil testing, ensure proper drainage, and design foundations for our conditions. Options include slab-on-grade, pier and beam, or basement foundations depending on lot characteristics. Proper site work prevents settling, cracking, and moisture issues. Experienced builders understand local geology and engineering requirements for stable, long-lasting foundations.`
    },
    {
      icon: 'ri-home-wifi-line',
      title: 'Smart Home Integration',
      description: `Modern custom homes incorporate smart technology from the planning stage. Integrated systems control lighting, climate, security, entertainment, and appliances through centralized interfaces. Pre-wiring during construction is more cost-effective than retrofitting. Popular features include automated shading for sun control, smart thermostats, security cameras, and whole-home audio. Technology enhances comfort, security, and energy efficiency while increasing home value.`
    },
    {
      icon: 'ri-landscape-line',
      title: 'Outdoor Living and Landscaping',
      description: `El Paso's climate is perfect for outdoor living spaces that extend your home's functionality. Custom builders design covered patios, outdoor kitchens, pools, and entertainment areas as integral parts of the home. Xeriscaping with native plants reduces water usage while creating beautiful landscapes. Quality construction includes proper drainage, irrigation systems, and materials that withstand our weather. Outdoor spaces add significant value and enjoyment to custom homes.`
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Custom Home Building Services in El Paso
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Building a custom home in El Paso requires specialized expertise in desert construction, energy efficiency, and regional architecture. Our featured builders deliver exceptional quality tailored to your vision and our unique climate.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
                <i className={`${service.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-sm text-gray-700 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
